import React, { useContext, useEffect, useRef, useState } from "react";
import { Form, Row, Col, Button, Table, Card } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { ToastContainer, toast } from "react-toastify";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {FaTimes} from 'react-icons/fa'

const AddExpenses = () => {
  const { id } = useParams();
  const [load, setLoad] = useState(false);
  const [errors, setErrors] = useState({});
  const [details, setDetails] = useState([]);
  const [expenses, setExpenses] = useState([{ title: "", price: "" }]);
  const [agenda , setAgenda] = useState("")
  const navigate = useNavigate();
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = {
    "auth-token": authToken,
    authorization: accessToken,
  };

  useEffect(() => {
    fetchDetails(id);
  }, [id]);

  useEffect(() => {
    if (details?.length) {
      const transformed = details.map((item) => ({
        title: item.title,
        price: item.price.toString(), // Make sure it's string for input
      }));
      setExpenses(transformed);
    }
  }, [details]);

  const fetchDetails = async (momId) => {
    try {
      const response = await APIServices.get(
        `/admin/mom/get_expenses/${momId}`,
        headers
      );
      if (response?.status === 200) {
        setAgenda(response?.data?.agenda)
        setDetails(response?.data?.list || {});
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setDetails([]);
      }
    } catch (error) {
      setDetails([]);
    }
  };

  const handleChangeExp = (index, field, value) => {
    const updated = [...expenses];
    updated[index][field] = value;
    setExpenses(updated);
  
    const updatedErrors = { ...errors };
  
    if (!updatedErrors[index]) {
      updatedErrors[index] = {};
    }
  
    if (field === "price" && updatedErrors[index].price) {
      delete updatedErrors[index].price;
    }
  
    if (field === "title" && updatedErrors[index].title) {
      delete updatedErrors[index].title;
    }
  
    setErrors(updatedErrors);
  };
  
  
  const addExpense = () => {
    setExpenses([...expenses, { title: "", price: "" }]);
  };

  const removeExpense = (index) => {
    const updated = expenses?.filter((_, i) => i !== index);
    setExpenses(updated);
  };

  const validate = () => {
    const newErrors = {};
  
    expenses.forEach((item, index) => {
      const itemErrors = {};
  
      if (!item.title) {
        itemErrors.title = ["Title is required."];
      }
  
      if (!item.price) {
        itemErrors.price = ["Price is required."];
      }
  
      if (Object.keys(itemErrors).length > 0) {
        newErrors[index] = itemErrors;
      }
    });
  
    return newErrors;
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setLoad(true);
      const formDataToSubmit = new FormData();

      formDataToSubmit.append("id", id);

      const validExpenses = expenses.filter((item) => item.title && item.price);
      if (validExpenses.length > 0) {
        formDataToSubmit.append("expenses", JSON.stringify(validExpenses));
      }
      try {
        const response = await APIServices.post(
          `/admin/mom/add_expenses`,
          formDataToSubmit,
          headers
        );
        if (response?.data?.status === true) {
          showToast(response?.data?.message || "Success", "success");
          setTimeout(() => {
            navigate(`/admin/mom-details/${id}`)
          }, 2000);
        } else if (response?.status === 401) {
          logout();
          navigate("/");
        } else {
          showToast(
            response?.data?.message || "Something went wrong.",
            "error"
          );
        }
      } catch (error) {
        showToast("Something went wrong.", "error");
      } finally {
        setLoad(false);
      }
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };
  return (
    <>
      <div className="addmom_inner">
        <div className="addmom_header d-flex justify-content-start mb-3">
        <h1 className="font_blue_18 font-600 d-flex align-items-center gap-2">
         Add Expenses 
         <span className="text-muted fs-6">{agenda ? `(${agenda})` : ""}</span>
       </h1>

        </div>
        <Card className="mom_form">
          <Card.Body>
            <Form className="">
              <Form.Group className="font_blue_14 font-500 mb-2">
                {expenses.map((item, index) => (
                  <div key={index}>
                    <Row
                      className="p-3 rounded mb-2"
                      style={{ backgroundColor: "#F1F3F6" }}
                    >
                      <Col md={6}>
                        <Form.Label>Expense Title</Form.Label>

                        <Form.Control
                          type="text"
                          placeholder=" Enter Expenses Title"
                          value={item.title}
                          maxLength={50}
                          onChange={(e) =>
                            handleChangeExp(index, "title", e.target.value)
                          }
                        />
                        {errors[index]?.title &&
                          errors[index].title.map((msg, i) => (
                            <div className="text-danger" key={i}>
                              {msg}
                            </div>
                          ))}
                      </Col>
                      <Col md={5}>
                        <Form.Label>Price</Form.Label>

                        <Form.Control
                          type="text"
                          placeholder="Enter Price"
                          value={item.price}
                          maxLength={8}
                          onChange={(e) =>
                            handleChangeExp(index, "price", e.target.value)
                          }
                          onKeyPress={(e) => {
                            const value = e.currentTarget.value;
                            if (
                              !/[0-9.]/.test(e.key) ||              // block anything that's not digit or dot
                              (e.key === '.' && value.includes('.')) // block more than one dot
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                        {errors[index]?.price &&
                          errors[index].price.map((msg, i) => (
                            <div className="text-danger" key={i}>
                              {msg}
                            </div>
                          ))}
                      </Col>

                     <Col md={1} className="d-flex align-items-center justify-content-center">
                      {expenses.length > 1 && (
                        <FaTimes
                          size={20} 
                          className="cursor-pointer"
                          onClick={() => removeExpense(index)}
                        />
                      )}
                    </Col>
                    </Row>
                  </div>
                ))}
                <div className="text-end mb-3">
                  <Button
                    variant="success"
                    className="btn btn-sm border "
                    onClick={addExpense}
                  >
                    + Add More
                  </Button>
                </div>
              </Form.Group>

              <div className="d-flex justify-content-end gap-2">
                <Button
                  className="btn blue_border"
                  onClick={() =>navigate(`/admin/mom-details/${id}`)}
                >
                  Cancel
                </Button>
                <Button
                  className="btn red_button"
                  onClick={handleSubmit}
                  disabled={load}
                >
                  {" "}
                  {load ? "Processing..." : "Save"}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>
      <ToastContainer />
    </>
  );
};

export default AddExpenses;
